<script setup lang="ts"></script>

<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.5 5.5H19.5" stroke-linecap="round" />
    <path d="M4.5 12H19.5" stroke-linecap="round" />
    <path d="M4.5 18.5H19.5" stroke-linecap="round" />
  </svg>
</template>
